import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-5 pt-6 pb-16">
      <Link to="/" className="text-xs font-mono-ui uppercase tracking-wider text-gray-400 hover:text-white" data-testid="terms-back">← Back</Link>
      <div className="eyebrow text-[#FD0F10] mt-6">TERMS AND DISCLAIMER</div>
      <h1 className="font-display text-3xl sm:text-4xl font-black mt-1">The fine print, in plain English.</h1>

      <section className="mt-8 space-y-4 text-gray-200 leading-relaxed text-sm sm:text-base">
        <div className="card-panel p-5">
          <div className="eyebrow text-[#FD0F10]">RESULTS DISCLAIMER</div>
          <p className="mt-3">
            What you build depends on you. Your effort, your time, your consistency, market conditions, personal circumstances, and other factors outside anyone's control all affect the outcome.
          </p>
          <p className="mt-3">
            The income ranges, potential earnings, timelines, and paths shown in this app are realistic possibilities based on proven side hustles that everyday people use to earn extra income. They are not promises, projections, or guarantees. Your results may be significantly different, higher or lower or nothing at all.
          </p>
          <p className="mt-3">
            Nothing in this app should be interpreted as financial, legal, tax, or investment advice. Always do your own research and consult qualified professionals for decisions specific to your situation.
          </p>
        </div>

        <div className="card-panel p-5" data-testid="terms-liability">
          <div className="eyebrow text-[#FD0F10]">SAFETY AND LIABILITY</div>
          <p className="mt-3">
            Everything in this app, including the AI Coach, sprints and path guides, is general information only. It is not professional, safety, legal or insurance advice, and it may be incomplete or wrong for your situation.
          </p>
          <p className="mt-3">
            For hands-on and local services (like pressure washing, painting, cleaning, pet care or moving), you are responsible for your own work, your safety, the safety of others, and any damage to property. Always confirm methods and products with experienced professionals, test on a small area first, and follow the manufacturer's instructions for any equipment or product.
          </p>
          <p className="mt-3">
            You are responsible for getting any licences, permits and insurance your area requires. We strongly recommend liability insurance before your first paid job.
          </p>
          <p className="mt-3">
            We make no guarantees about results or safety. To the fullest extent the law allows, I Hate My Job and its owners are not liable for any injury, damage, loss or claim that comes from using the information in this app or from work you do.
          </p>
        </div>

        <div className="card-panel p-5">
          <div className="eyebrow text-[#FD0F10]">HOW WE USE YOUR DATA</div>
          <p className="mt-3">
            We store the answers you give us in the quiz so we can personalize your paths, coach responses, and roadmap. We do not sell your data. If you opted in to updates, we email you occasionally in the same voice you see in the app.
          </p>
          <p className="mt-3">
            You can request deletion of your account and data at any time by emailing us. We aim to respond within seven days.
          </p>
        </div>

        <div className="card-panel p-5">
          <div className="eyebrow text-[#FD0F10]">PAYMENTS AND SUBSCRIPTIONS</div>
          <p className="mt-3">
            Signing up and the 7-Day Launch Sprint are free. Pro Escape Pass is 19 USD/month or 149 USD/year. Cancel anytime. 7-day refund on Pro. Pro subscriptions are handled by Stripe. You can cancel any time from your account billing portal. Not a fit? Get a full refund within 7 days of your first payment. Cancel anytime. Renewals are non-refundable. Prices, billing cadence, and features may change over time and we will notify active subscribers before changes take effect.
          </p>
        </div>

        <div className="card-panel p-5">
          <div className="eyebrow text-[#FD0F10]">TL;DR</div>
          <p className="mt-3">
            We are on your side. We show you real paths, honest ranges, and the next right move. What you do with them is up to you.
          </p>
        </div>
      </section>
    </div>
  );
}
